import { Box, Grid, Typography } from "@mui/material"
import { useDrawerInputs } from "../../../../hooks/evidences/useEvidences"
import CustomAccordion from "../../../accordion"
import { DynamicFormRef } from "../../../dynamicFormRef"
import { DinamicFormRefValues } from "../../../dynamicFormRef/types"
import { ItemProps } from "./types"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { Fragment } from "react"

const Item = ({ expand, refs, addData, data, validateData, existCheck, index, disabledField }: ItemProps) => {
    const styles = useStyles()
    const validateIndex = index + 1
    const { model } = useDrawerInputs({ disabled: !!disabledField })
    const { t } = useTranslation()

    return (
        <Fragment key={index + 1}>
            {
                Object.entries(model).map(([key, value]) => (
                    <CustomAccordion
                        key={`${key}-${expand?.[key]}`}
                        expanded={!!expand?.[key]}
                        expandIcon={null}
                        title={<DynamicFormRef
                            ref={element => {
                                refs.setRef(element, `${key}-header-${validateIndex}`)
                                return refs.refsByKey[`${key}-header-${validateIndex}`]
                            }}
                            styleSx={{ width: "100%" }}
                            removeForm
                            onChange={(payload) => {
                                const name = payload?.current as string
                                addData({ key, name, value: payload?.[name] as DinamicFormRefValues, oldValue: payload?.oldValue ?? '' })
                            }}
                            defaultValues={data?.[key]}
                            model={{
                                ...value?.header,
                                required: !!expand?.[key] ? value?.header.required : null
                            }}
                            parentWrapper={({ children }) => <Grid sx={styles.labels} container justifyContent="space-between" alignItems="center" children={children} />}
                        />}
                        description={
                            (
                                <>
                                    {!!value?.check && (
                                        <DynamicFormRef
                                            ref={element => {
                                                refs.setRef(element, `${key}-check-${validateIndex}`)
                                                return refs.refsByKey[`${key}-check-${validateIndex}`]
                                            }}
                                            onChange={(payload) => {
                                                const name = payload?.current as string
                                                addData({ key, name, value: payload?.[name] as DinamicFormRefValues, oldValue: payload?.oldValue ?? '' })
                                            }}
                                            removeForm
                                            model={value?.check}
                                            defaultValues={data?.[key]}
                                            parentWrapper={({ children }) => (
                                                <Box>
                                                    {
                                                        !!existCheck?.[key] && (
                                                            <Typography sx={styles.noSelected}>
                                                                <span>*</span> {t('general.validations.selectACheck')}
                                                            </Typography>
                                                        )
                                                    }

                                                    <Grid sx={styles.labels} container justifyContent="center" alignItems="center" children={children} />
                                                </Box>
                                            )}
                                        />
                                    )}

                                    <DynamicFormRef
                                        ref={element => {
                                            refs.setRef(element, `${key}-input-${validateIndex}`)
                                            return refs.refsByKey[`${key}-input-${validateIndex}`]
                                        }}
                                        onChange={(payload) => {
                                            const name = payload?.current as string
                                            addData({ key, name, value: payload?.[name] as DinamicFormRefValues, oldValue: payload?.oldValue ?? '' })
                                        }}
                                        onBlur={(payload) => {
                                            const name = payload?.current as string
                                            validateData({ key, name, value: payload?.[name] as DinamicFormRefValues, oldValue: payload?.oldValue ?? '' })
                                        }}
                                        removeForm
                                        model={value?.input}
                                        defaultValues={data?.[key]}
                                        parentWrapper={({ children }) => <Grid sx={styles.labels} container spacing={2} justifyContent="center" alignItems="center" children={children} />}
                                    />
                                </>
                            )
                        }
                    />
                ))
            }
        </Fragment>
    )
}

export { Item }